import styled, {css} from 'styled-components'

export const StyledEntityActivityLogs = styled.div(
    ({theme: {spacing, palette}}) => css`
        background-color: ${palette.neutral[50]};
        padding: ${spacing * 2}px;
    `
)
